import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "pwa-more" }
const _hoisted_2 = { class: "profile-avatar" }
const _hoisted_3 = { class: "profile-info" }
const _hoisted_4 = { class: "profile-name" }
const _hoisted_5 = { class: "center-info-card" }
const _hoisted_6 = { class: "center-icon" }
const _hoisted_7 = { class: "center-details" }
const _hoisted_8 = { class: "center-name" }
const _hoisted_9 = { class: "center-code" }
const _hoisted_10 = { class: "menu-section" }
const _hoisted_11 = { class: "menu-group" }
const _hoisted_12 = { class: "menu-list" }
const _hoisted_13 = { class: "menu-icon purple" }
const _hoisted_14 = { class: "menu-group" }
const _hoisted_15 = { class: "menu-list" }
const _hoisted_16 = { class: "menu-icon orange" }
const _hoisted_17 = { class: "menu-group" }
const _hoisted_18 = { class: "menu-list" }
const _hoisted_19 = { class: "menu-icon blue" }
const _hoisted_20 = { class: "menu-icon gray" }
const _hoisted_21 = { class: "menu-group" }
const _hoisted_22 = { class: "menu-list" }
const _hoisted_23 = { class: "menu-icon red" }

import { computed } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';


export default /*@__PURE__*/_defineComponent({
  __name: 'PwaSettings',
  setup(__props) {

const store = useStore();
const router = useRouter();

const userInfo = computed(() => store.state.user);

const goToUserInfo = () => router.push('/pwa/userinfo');

const handleInquiry = () => {
  window.location.href = 'tel:070-1234-5678';
};

const handleLogout = async () => {
  try {
    await store.dispatch('pwa/performPwaLogout');
  } catch (error) {
    console.error('로그아웃 오류:', error);
    store.commit('pwa/clearPwaUser');
  }
  router.push('/pwa/login');
};

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[20] || (_cache[20] = _createElementVNode("div", { class: "more-header" }, [
      _createElementVNode("span", { class: "page-title" }, "더보기")
    ], -1)),
    _createElementVNode("div", {
      class: "profile-card",
      onClick: goToUserInfo
    }, [
      _createElementVNode("div", _hoisted_2, _toDisplayString(userInfo.value?.m_name?.charAt(0) || userInfo.value?.m_user_name?.charAt(0) || '?'), 1),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, _toDisplayString(userInfo.value?.m_name || userInfo.value?.m_user_name || '사용자'), 1),
        _cache[0] || (_cache[0] = _createElementVNode("span", { class: "profile-role" }, "센터장", -1))
      ]),
      _createVNode(_component_v_icon, {
        size: "20",
        color: "#ccc"
      }, {
        default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
          _createTextVNode("mdi-chevron-right", -1)
        ]))]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_v_icon, {
          size: "24",
          color: "#1e3a8a"
        }, {
          default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
            _createTextVNode("mdi-domain", -1)
          ]))]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("span", _hoisted_8, _toDisplayString(userInfo.value?.m_sisul_name || '센터'), 1),
        _createElementVNode("span", _hoisted_9, _toDisplayString(userInfo.value?.m_sisul_code || '-'), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _cache[6] || (_cache[6] = _createElementVNode("span", { class: "group-title" }, "보고서", -1)),
        _createElementVNode("div", _hoisted_12, [
          _createVNode(_component_router_link, {
            to: "/pwa/report",
            class: "menu-item"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_13, [
                _createVNode(_component_v_icon, {
                  size: "18",
                  color: "white"
                }, {
                  default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                    _createTextVNode("mdi-file-chart", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _cache[5] || (_cache[5] = _createElementVNode("span", { class: "menu-label" }, "보고서 생성", -1)),
              _createVNode(_component_v_icon, {
                size: "18",
                color: "#ddd"
              }, {
                default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                  _createTextVNode("mdi-chevron-right", -1)
                ]))]),
                _: 1
              })
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _cache[10] || (_cache[10] = _createElementVNode("span", { class: "group-title" }, "알림", -1)),
        _createElementVNode("div", _hoisted_15, [
          _createVNode(_component_router_link, {
            to: "/pwa/notice",
            class: "menu-item"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_16, [
                _createVNode(_component_v_icon, {
                  size: "18",
                  color: "white"
                }, {
                  default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                    _createTextVNode("mdi-bell", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _cache[9] || (_cache[9] = _createElementVNode("span", { class: "menu-label" }, "공지사항", -1)),
              _createVNode(_component_v_icon, {
                size: "18",
                color: "#ddd"
              }, {
                default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                  _createTextVNode("mdi-chevron-right", -1)
                ]))]),
                _: 1
              })
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_17, [
        _cache[17] || (_cache[17] = _createElementVNode("span", { class: "group-title" }, "설정", -1)),
        _createElementVNode("div", _hoisted_18, [
          _createVNode(_component_router_link, {
            to: "/pwa/userinfo",
            class: "menu-item"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_19, [
                _createVNode(_component_v_icon, {
                  size: "18",
                  color: "white"
                }, {
                  default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                    _createTextVNode("mdi-account-cog", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _cache[13] || (_cache[13] = _createElementVNode("span", { class: "menu-label" }, "내 정보 수정", -1)),
              _createVNode(_component_v_icon, {
                size: "18",
                color: "#ddd"
              }, {
                default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                  _createTextVNode("mdi-chevron-right", -1)
                ]))]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createElementVNode("div", {
            class: "menu-item",
            onClick: handleInquiry
          }, [
            _createElementVNode("div", _hoisted_20, [
              _createVNode(_component_v_icon, {
                size: "18",
                color: "white"
              }, {
                default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                  _createTextVNode("mdi-headset", -1)
                ]))]),
                _: 1
              })
            ]),
            _cache[15] || (_cache[15] = _createElementVNode("span", { class: "menu-label" }, "고객센터", -1)),
            _cache[16] || (_cache[16] = _createElementVNode("span", { class: "menu-sub" }, "070-1234-5678", -1))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_21, [
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("div", {
            class: "menu-item logout",
            onClick: handleLogout
          }, [
            _createElementVNode("div", _hoisted_23, [
              _createVNode(_component_v_icon, {
                size: "18",
                color: "white"
              }, {
                default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
                  _createTextVNode("mdi-logout", -1)
                ]))]),
                _: 1
              })
            ]),
            _cache[19] || (_cache[19] = _createElementVNode("span", { class: "menu-label danger" }, "로그아웃", -1))
          ])
        ])
      ])
    ]),
    _cache[21] || (_cache[21] = _createElementVNode("div", { class: "app-info" }, [
      _createElementVNode("span", { class: "app-name" }, "CAION"),
      _createElementVNode("span", { class: "app-version" }, "v1.0.0")
    ], -1))
  ]))
}
}

})